import { props as searchBoxProps } from "#ce/components/SpSearchBox/props.js";

export const props = Object.freeze({
  /**
   * Google Maps browser API key used to load the Places library. Supplied once at element
   * registration from the app's configuration rather than per call site.
   *
   * @type {String}
   */
  apiKey: { type: String, required: true, external: true },
  /**
   * Place fields requested for each prediction. Array data has no attribute form — set it as a
   * DOM property (`:fields.prop` in a template, `el.fields = …` in script).
   *
   * @type {Array}
   * @default ["place_id"]
   */
  fields: { type: Array, default: () => ["place_id"] },
  /**
   * Place types the predictions are restricted to. Set as a DOM property, not an attribute.
   *
   * @type {Array}
   * @default ["geocode"]
   */
  types: { type: Array, default: () => ["geocode"] },
  /**
   * Country restriction passed to the Places request. Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @default { country: "us" }
   */
  componentRestrictions: { type: Object, default: () => ({ country: "us" }) },
  /**
   * Label rendered above the field. Omit for an unlabelled input.
   *
   * @type {String}
   * @default undefined
   */
  label: { type: String, default: undefined },
  /**
   * Placeholder shown in the empty field.
   *
   * @type {String}
   * @default undefined
   */
  placeholder: { type: String, default: undefined },
  /**
   * Programmatic query text: seeds the field and mirrors host-driven changes (a selected
   * result's display name, a clear) into it. The element keeps its own live text while the
   * user types, so the host does not need to echo `update-search-query` back.
   *
   * @type {String}
   * @default ""
   */
  searchQuery: { type: String, default: "" },
  /**
   * Density of the inner `sp-search-box`. The definition is borrowed from `SpSearchBox`, so its
   * validator is not in this file and the options are listed here for the docs table.
   *
   * @type {String}
   * @values default, compact, comfortable
   * @storybook-control select
   */
  inputDensity: { ...searchBoxProps.density },
  /**
   * `data-testid` applied to the inner `<input>`.
   *
   * @type {String}
   */
  inputTestId: { ...searchBoxProps.inputTestId },
});
